<template>
  <div ref="dynamiclist">
    <div class="dynamictopbg">
      <div class="fixtopbox">
        <div class="backbtn" @click="backgoto"><img :src="backicon" /></div>
      </div>
      <div class="topfixbox" v-show="topfixshow">
        <span>
          <img :src="dynamiccontent.avatar_url" />
        </span>
      </div>
      <div class="dynamictopbox">
        <div class="quanzitopmain">
          <div class="quanzitop-pic">
            <img :src="dynamiccontent.avatar_url" />
            <div class="quanzitop-style"></div>
            <div class="quanzitop-style-text">圈子</div>
          </div>

          <div class="quanzitop-titlebox">
            <div class="quanzitop-biaoti">{{dynamiccontent.like_name}}</div>
            <div class="quanzitop-data">
              <span>阅读 {{dynamiccontent.reader_num}}</span>
              <span>帖子 {{dynamiccontent.message_num}}</span>
              <span>粉丝 {{dynamiccontent.fans_num}}</span>
            </div>
            <div class="quanzitop-follow">
              <div class="quanzitop-follow-01 quanzitop-follow-new1" v-if="dynamiccontent.is_follow_like == 0" @click="followthecircle">
                <span>+</span> 关注
              </div>
              <div class="quanzitop-follow-01 quanzitop-follow-new1" v-else @click="followthecircle">已关注</div>
              <button class="dy-sharebtn quanzitop-follow-new2" @click="showPopup" v-clipboard:copy="config.link">分享</button>
            </div>
          </div>
        </div>
      </div>

      <div class="quanzitopbg global-blur2">
        <!--   <img :src="dynamiccontent.avatar_url" /> -->
      </div>
    </div>

    <div class="dynamiclist">
      <van-sticky :offset-top="70">
        <div class="dynamictab">
          <ul>
            <li :class="dqactive == 0 ? 'active' : ''" @click="goalldynamic">
              <span>全部动态({{alltotal}})</span>
            </li>
            <li :class="dqactive == 1 ? 'active' : ''" @click="goimgdynamic">
              <span>图文动态</span>
            </li>
            <li :class="dqactive == 2 ? 'active' : ''" @click="govideodynamic">
              <span>视频动态</span>
            </li>
          </ul>
        </div>
      </van-sticky>

      <div class="nodynamiclist" v-if="nodynamic || dynamiclistdata.length==0">
        <div class="nofollowpic">
          <img :src="nodynamicpic" />
          <p>暂无动态</p>
        </div>
        <div class="gotofollow" @click="gotopublish">
          <button>立即去发布</button>
        </div>
      </div>
      <div v-else>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div v-for="(item,index) in dynamiclistdata" :key="index">
            <circledylist :dynamiclistdata="item" :allnamiclistdata="dynamiclistdata" :alldynamiccnum="dynamiccontent.totalCount" :dylistindex="index"></circledylist>
          </div>
        </van-list>
      </div>
    </div>

    <div class="releasebtn" @click="gotopublish">
      <img :src="publishbtn" />
    </div>

    <!--分享到-->
    <van-popup v-model="showpopup" position="bottom" :style="{ height: '50%' }">
      <div class="sharedownbox">
        <vue-native-share :shareMenu="shareMenu" :config="config" />
      </div>
      <van-button class="sharetopbox" @click="closepopup" type="default" block>取消分享</van-button>
    </van-popup>
  </div>
</template>

<script>
import {
  getmydynamic,
  getfollowpeople,
  getcircledylist,
  gettofollowcircle
} from "../../api/api";
import { Toast } from "vant";
import vueNativeShare from "../plugins/vue-native-share";
import circledylist from "../public/circledylist.vue";
import Bus from "@/assets/js/bus.js";
import axios from "axios";
import backbtn from "../public/backbtn";
export default {
  name: "circlecontent",
  components: {
    circledylist,
    backbtn,
    vueNativeShare
  },
  data () {
    return {
      backicon: require('../../assets/images/back_new.png'),
      list: [],
      dqactive: 0,
      showpopup: false,
      topfixshow: false,
      isdytemple: true, //表示是动态的模板
      dynamiccontent: {},
      avatar_url: require("../../assets/images/moren.jpg"),
      followicon01: require("../../assets/images/dynamic_btn_attention_selected.png"),
      followicon02: require("../../assets/images/dynamic_btn_attention_normal.png"),
      publishicon: require("../../assets/images/dynamic_icon_release.png"),
      shareicon: require("../../assets/images/dynamic_icon_share.png"),
      mycaricon: require("../../assets/images/dynamic_icon_business.png"),
      nodynamicpic: require("../../assets/images/circle_icon_wu.png"),
      dynamiclistdata: [], //动态列表
      newdynamiclistdata: [],
      alltotal: 0,
      publishbtn: require("../../assets/images/dynamic_icon_edit.png"),
      page: 0, //分页请求
      pageCount: 0,
      loading: false,
      finished: true,
      nodynamic: false,
      msg_type: 0,
      shareMenu: [0, 1, 2, 3],
      cid: "",
      config: {
        title: "鲜枇杷名片-圈子",
        desc: "免费为企业/个人制作电子名片，扫描二维码生成你的专属电子名片",
        img: "https://api.xianpipa.com/xianpipa/images/logo.png",
        img_title: "一款名片应用",
        link: "",
        success: () => {
          console.log("success");
        },
        cancel: () => {
          console.log("cancel");
        }
      }
    };
  },

  beforeRouteEnter (to, from, next) {
    if (from.name == "circlelist" || from.name == "circlefollow") {
      // 这个name是下一级页面的路由name
      to.meta.keepAlive = false;
    } else if (from.name == "dynamic" || from.name == "dynamicdetails") {
      to.meta.keepAlive = true;
    }
    next();
  },

  created () {
    document.title = "圈子";
    window.scrollTo(0, 0);
    var url = window.location.href;
    this.config.link = url;
    window.scrollTo(0, 0);
    let that = this;
    var cid = "";
    if (this.$route.query.id) {
      cid = this.$route.query.id;
      this.cid = this.$route.query.id;
    }
    getcircledylist(cid)
      .then(res => {
        if (res.data.code == 200) {
          that.dynamiccontent = res.data.data;
          console.log('圈子数据：', that.dynamiccontent)
          that.dynamiclistdata = res.data.data.list;
          that.newdynamiclistdata = res.data.data.list;
          that.alltotal = res.data.data.totalCount;
          that.loading = false;
          that.pageCount = res.data.data.pageCount;
          that.finished = false;

          if (res.data.data.totalCount > 0) {
            that.nodynamic = false;
          } else {
            that.nodynamic = true;
          }
        } else {
          that.nodynamic = true;
          Toast.fail("数据异常，请刷新！");
        }
      })
      .catch(err => {
      });
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
    //bus传值
    this.jieshou();
  },
  methods: {
    backgoto () {

      this.$router.go(-1)

    },
    showPopup () {
      if (/micromessenger/i.test(navigator.userAgent)) {
        //微信复制链接
        Toast.success({
          duration: 2000,
          message: "链接已复制，快去分享吧！"
        });
      } else {
        this.showpopup = true;
      }
    },
    closepopup () {
      this.showpopup = false;
    },
    jieshou () {
      Bus.$on("alldynamiccnum", res => {
        this.alltotal = res;
      });
    },
    gotopublish () {
      this.$router.push({
        path: "/publish",
        query: {
          circlecome: true,
          cid: this.dynamiccontent.like_id,
          circlename: this.dynamiccontent.like_name
        }
      });
    },
    gototacart (e) {
      if (this.dynamiccontent.is_own == 1) {
        this.$router.push({
          name: "mindex"
        });
      } else {
        let id = e;
        this.$router.push({
          name: "othercart",
          params: {
            id: id
          }
        });
      }
    },
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        let cid = this.dynamiccontent.like_id;
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page >= pageCount) {
          this.finished = true;
          this.loading = false;
          return;
        }

        this.page = page;

        let msg_type = this.msg_type;

        getcircledylist(cid, msg_type, page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let dynamiclistarr = that.dynamiclistdata;
            let newarr = res.data.data.list;

            newarr.forEach(function (e) {
              dynamiclistarr.push(e);
            });
          }
        });
      }, 500);
    },

    //关注圈子
    followthecircle () {
      let that = this;
      let circleid = this.dynamiccontent.like_id;
      //let fromfollow=1;

      gettofollowcircle(circleid).then(res => {
        if (res.code == 200) {
          let msg_type = 0;
          that.getcircledylist(circleid, msg_type);
          Toast(res.message);
        } else {
          Toast(res.message);
        }
      });
    },

    //全部动态
    goalldynamic () {
      this.dqactive = 0;
      let cid = this.dynamiccontent.like_id;
      let msg_type = 0;
      this.msg_type = 0;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getcircledylist(cid, msg_type);
    },
    goimgdynamic () {
      this.dqactive = 1;
      let cid = this.dynamiccontent.like_id;
      let msg_type = 1;
      this.msg_type = 1;
      this.$refs.dynamiclist.scrollTop = 0;
      this.getcircledylist(cid, msg_type);
    },
    govideodynamic () {
      this.dqactive = 2;
      let cid = this.dynamiccontent.like_id;
      let msg_type = 2;
      this.msg_type = 2;
      //this.$refs.dynamiclist.scrollTop = 0;
      this.getcircledylist(cid, msg_type);
    },

    getcircledylist (otherrenid, msg_type) {
      window.scrollTo(0, 0);

      let that = this;
      let page = 0;
      getcircledylist(otherrenid, msg_type, page).then(res => {
        if (res.data.code == 200) {
          this.dynamiccontent = res.data.data;
          this.dynamiclistdata = res.data.data.list;
          this.newdynamiclistdata = res.data.data.list;
          //this.alltotal = res.data.data.totalCount;
          this.loading = false;
          this.pageCount = res.data.data.pageCount;
          this.finished = false;

          if (res.data.data.totalCount > 0) {
            that.nodynamic = false;
          } else {
            that.nodynamic = true;
          }
        } else {
          that.nodynamic = true;
          Toast.fail("数据异常，请刷新！");
        }
      });
    },
    handleScroll () {
      var top = Math.floor(
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageXOffset
      );
      if (top > 120) {
        this.topfixshow = true;
      } else {
        this.topfixshow = false;
      }
    },

    //关注人
    followpeople (e) {
      let userid = e;
      let that = this;
      let isfollow = this.dynamiccontent.is_follow;
      let msg_type = this.msg_type;
      //let circleid = this.circleid;
      //let dynamiccontent = this.data.dynamiccontent;
      getfollowpeople(userid).then(res => {
        if (res.code == 200) {
          if (isfollow == 0) {
            this.dynamiccontent.is_follow = 1;
            isfollow = 1;
          } else {
            this.dynamiccontent.is_follow = 0;
            isfollow = 0;
          }
        } else if (res.code == 412) {
          Toast(res.message);
        } else {
          Toast(res.message);
        }
      });
    }
  },
  activated () {
    document.title = "圈子";
    this.page = 0;
    let that = this;
    var cid = "";
    let msg_type = this.msg_type;
    if (this.$route.query.id) {
      cid = this.$route.query.id;
      //localStorage.setItem('cid',cid);
    }
    getcircledylist(cid, msg_type).then(res => {
      if (res.data.code == 200) {
        that.dynamiccontent = res.data.data;
        that.dynamiclistdata = res.data.data.list;
        that.newdynamiclistdata = res.data.data.list;
        that.alltotal = res.data.data.totalCount;
        that.loading = false;
        that.pageCount = res.data.data.pageCount;
        that.finished = false;

        if (res.data.data.totalCount > 0) {
          that.nodynamic = false;
        } else {
          that.nodynamic = true;
        }
      } else {
        that.nodynamic = true;
        Toast.fail("数据异常，请刷新！");
      }
    });
  }
};
</script>

<style scoped>
.dynamictopbg .van-sticky {
  position: fixed;
  width: 100%;
  z-index: -1;
  background: #fff;
  padding-top: 20px;
}
.dynamictopbg .van-sticky--fixed {
  background: #fff;
  height: 1rem;
  width: 100%;
}
.fixtopbox {
  width: 100%;
  z-index: -1;
  background: none;
}
.topfixbox {
  position: fixed;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 4rem;
  background: rgba(255, 255, 255, 0.85);
  text-align: center;
}
.topfixbox span {
  padding-top: 0.85rem;
  display: inline-block;
}
.topfixbox span img {
  width: 1.8rem;
  border-radius: 50%;
}
.dynamictopbg {
  position: relative;
  overflow: hidden;
  height: 9.72972972972973rem;
}
.dynamictopbg img {
  width: 100%;
}
.backbtn {
  padding-left: 1rem;
  position: fixed;
  z-index: 50;
  top: 0.7rem;
}
.dynamictopbg .dynamictopbox {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
}
.dynamictopbg .dynamictopbox .dynamictop-pic {
  text-align: center;
}

.dynamictopbox .dynamictopmain .dynamictop-pic img {
  width: 4.267rem;
  height: 4.267rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.38);
}
.dynamictopbox .dynamictopmain .dynamictop-name {
  color: #fff;
  text-align: center;
  padding-top: 0.53rem;
  font-size: 0.92rem;
}
.dynamictopbox .dynamictopmain .dynamictop-funs {
  text-align: center;
  color: #fff;
  padding-top: 0.2rem;
}
.dynamictopbox .dynamictopmain .dynamictop-funs span {
  padding-left: 0.267rem;
  padding-right: 0.267rem;
  font-size: 0.747rem;
}

.dynamictab {
  background: #fff;
  height: 2.347rem;
  border-bottom: 1px solid #efefef;
}
.dynamictab ul {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  line-height: 2.347rem;
  height: 2.347rem;
  padding-left: 1.1rem;
  padding-right: 0.3rem;
}
.dynamictab ul li {
  font-size: 0.747rem;
  color: #666;
  width: 5.8rem;
  text-align: center;
}
.dynamictab ul li.active {
  color: #ffbd0a;
}

.quanzitopbg {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
  overflow: hidden;
}

.global-blur2 {
  /* FireFox, Chrome, Opera */
  background-position: center;
  background-size: cover;
  background-position: 100%;
  height: 8.72972972972973rem;
  -webkit-filter: blur(3px);
  /* Chrome, Opera */
  -moz-filter: blur(3px);
  -ms-filter: blur(3px);
  filter: blur(3px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=10, MakeShadow=false);
  /* IE6~IE9 */
}
.quanzitopbg img {
  position: absolute;
  top: -55%;
  width: 100%;
}

.releasebtn {
  width: 2.972972972972973rem;
  height: 2.972972972972973rem;
  position: fixed;
  right: 0.6756756756756757rem;
  bottom: 9.72972972972973rem;
  z-index: 30;
}
.releasebtn img {
  width: 2.972972972972973rem;
  height: 2.972972972972973rem;
}

.dynamictopbox .quanzitopmain {
  padding-top: 3.054054054054054rem;
  padding-left: 0.9459459459459459rem;
}
.dynamictopbox .quanzitopmain .quanzitop-pic {
  flex: 1 1 4.324324324324325rem;
  width: 4.324324324324325rem;
  height: 4.324324324324325rem;
  float: left;
  border-radius: 0.5405405405405406rem;
  overflow: hidden;
  position: relative;
  border: 2px solid rgba(255, 255, 255, 0.38);
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-style {
  left: -1.718918918918919rem;
  top: -0.66916216216216217rem;
  position: absolute;
  width: 0;
  height: 0;
  border-right: 2rem solid transparent;
  border-left: 2rem solid transparent;
  border-bottom: 2rem solid #d28248;
  transform: rotate(-45deg);
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-style-no01 {
  border-bottom: 1.6756756756756757rem solid rgba(246, 210, 84, 0.9);
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-style-no02 {
  border-bottom: 1.6756756756756757rem solid rgba(211, 224, 241, 0.9);
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-style-no03 {
  border-bottom: 1.6756756756756757rem solid rgba(238, 147, 120, 0.9);
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-style-text {
  position: absolute;
  left: 0.05405405405405406rem;
  top: 0.25rem;
  transform: rotate(-45deg);
  font-size: 0.6rem;
  color: #fff;
}
.dynamictopbox .quanzitopmain .quanzitop-pic .quanzitop-no {
  height: 0.972972972972973rem;
  background: #d28248;
  position: absolute;
  bottom: -0.08108108108108109rem;
  width: 100%;
  line-height: 0.918918918918919rem;
  text-align: center;
  color: #fff;
  font-size: 0.6486486486486487rem;
}
.dynamictopbox .quanzitopmain .quanzitop-pic .circle-cell-pic-no01 {
  background: rgba(246, 210, 84, 0.9);
  color: #eb7c3a;
}
.dynamictopbox .quanzitopmain .quanzitop-pic .circle-cell-pic-no02 {
  background: rgba(211, 224, 241, 0.9);
  color: #7a98b4;
}
.dynamictopbox .quanzitopmain .quanzitop-pic .circle-cell-pic-no03 {
  background: rgba(238, 147, 120, 0.9);
  color: #b04b32;
}
.dynamictopbox .quanzitopmain .quanzitop-pic img {
  width: 4.324324324324325rem;
  height: 4.324324324324325rem;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox {
  flex: 5 1 13.5rem;
  width: 13.5rem;
  float: left;
  padding-left: 0.8rem;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox .quanzitop-biaoti {
  font-size: 0.972972972972973rem;
  color: #333;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox .quanzitop-data {
  font-size: 0.7027027027027027rem;
  color: #333;
  padding-top: 0.40540540540540543rem;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox .quanzitop-data span {
  margin-right: 0.43243243243243246rem;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox .quanzitop-follow {
  padding-top: 0.4594594594594595rem;
}
.dynamictopbox .quanzitopmain .quanzitop-titlebox .quanzitop-follow div {
  width: 3.2432432432432434rem;
  height: 1.2972972972972974rem;
  border: 1px solid #fff;
  border-radius: 0.2702702702702703rem;
  text-align: center;
  line-height: 1.33rem;
  font-size: 0.7027027027027027rem;
  color: #fff;
  float: left;
  margin-right: 0.6486486486486487rem;
}
.dynamictopbox
  .quanzitopmain
  .quanzitop-titlebox
  .quanzitop-follow
  .dy-sharebtn {
  width: 3.2432432432432434rem;
  height: 1.38rem;
  border: 1px solid #a5de61;
  background: none;
  border-radius: 0.2702702702702703rem;
  text-align: center;
  line-height: 1.38rem;
  font-size: 0.7027027027027027rem;
  color: #a5de61;
  float: left;
  margin-right: 0.6486486486486487rem;
}

.nodynamiclist {
  padding-top: 4.054054054054054rem;
}
.nodynamiclist .nofollowpic {
  text-align: center;
}
.nodynamiclist .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nodynamiclist .nofollowpic p {
  font-size: 0.78rem;
  color: #999;
  padding-top: 0.2rem;
}
.nodynamiclist .gotofollow {
  padding-top: 1.2702702702702702rem;
  text-align: center;
}
.nodynamiclist .gotofollow button {
  width: 5.405405405405405rem;
  height: 1.8918918918918919rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  font-size: 0.7567567567567568rem;
  color: #fff;
  border: none;
  border-radius: 50px;
}

.sharedownbox {
  padding-top: 0rem;
}
.sharetopbox {
  position: absolute;
  bottom: 0;
}
.dynamictopbox
  .quanzitopmain
  .quanzitop-titlebox
  .quanzitop-follow
  .quanzitop-follow-new1 {
  color: #ffbd0a;
  border: 1px solid #ffbd0a;
}
.backbtn img {
  width: 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/circlecontent.vue